import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD_sZstuQWVr-Z0f6j3yre9m31sLMBjIiE",
  authDomain: "gsat-game.firebaseapp.com",
  projectId: "gsat-game",
  storageBucket: "gsat-game.firebasestorage.app",
  messagingSenderId: "1033639816240",
  appId: "1:1033639816240:web:54bc4bbfe6248b6c4891f5",
  measurementId: "G-HB3KL4RCJC"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
